






























































import Vue from 'vue';
import { ChildType } from '../types/interface';

export default Vue.extend({
    data() {
        return {
            statistics: ChildType.Statistics,
            engineValue: ChildType.EngineValue,

            curPoint: {},
        }
    },
    props: ['dialogVisible', 'pointDetail', 'pointDetailOption'],
    computed: {
        childValueTyleOptions(): any[] {
            return this.pointDetailOption && this.pointDetailOption.childValueTyleOptions || [];
        },
        periodOptions(): any[] {
            return this.pointDetailOption && this.pointDetailOption.periodOptions || [];
        },
        aggregateOptions(): any[] {
            return this.pointDetailOption && this.pointDetailOption.aggregateOptions || [];
        },
        periodAggregateOption(): any[] {
            return this.pointDetailOption && this.pointDetailOption.periodAggregateOption || [];
        },
        pointDialog: {
            get(): boolean {
                return this.dialogVisible;
            },
            set(toggle: boolean) {
                this.$emit('handleDialogVisible', toggle);
            }
        },
        childValueTyle: {
            get(): string {
                return String(this.pointDetail.childValueTyle || 1);
            },
            set(value: string) {
                this.$emit('editPointDetail', 'childValueTyle', Number(value));
            }
        },
        period: {
            get(): boolean {
                return this.pointDetail.period;
            },
            set(value: string) {
                this.$emit('editPointDetail', 'period', value);
            }
        },
        aggregate: {
            get(): boolean {
                return this.pointDetail.aggregate;
            },
            set(value: string) {
                this.$emit('editPointDetail', 'aggregate', value);
            }
        },
        periodAggregate: {
            get(): boolean {
                return this.pointDetail.periodAggregate;
            },
            set(value: string) {
                this.$emit('editPointDetail', 'periodAggregate', value);
            }
        },
    },
    methods: {
        addCheckPoint() {
            this.$emit('addCheckPoint')
        }
    }
})
